import { IUPCDataError } from "helpers/validators/import-UPC-validator/types";

export type UPCUploaderProviderLocalState = {};

export type UPCUploaderContextValues = {
    handleDropFile?: (file: File, onSettled: (error: boolean) => void) => Promise<void>;
    resetStates?: () => void;
    handleImport?: () => void;
    errorMessages: IUPCDataError;
    isUploading: boolean;
    wasProcessed: boolean;
    hasDataToChange: boolean;
    importUpcStatus: ImportUpcStatus;
    showTitleError: boolean;
};

export type IUploadDataError = {
    string?: string;
};

export enum ImportUpcStatus {
    NOT_STARTED,
    STARTED,
    FINISHED,
}
